import React from "react";
import classNames from "classnames";

export const Table = ({ children, className }) => {
    // Athuga hvort children innihaldi thead eða tbody element
    const hasTableStructure = React.Children.toArray(children).some(
        (child) =>
            child && typeof child === "object" && (child.type === "thead" || child.type === "tbody")
    );

    return (
        <div className="table-responsive">
            <table className={classNames("table", className)}>
                {hasTableStructure ? children : <tbody>{children}</tbody>}
            </table>
        </div>
    );
};
